
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
    VipPaySettingService,
    OptionSettingsDto,
    VipPriceDto,
} from "@/api/service-proxies";
import moment from "moment";
import EditRegistrationDialog from './edit-registrationdialog.vue'

class PayDetail {
    schoolId!: number;
    shcoolName!: string;
    pays: VipPriceDto[] = [];
}

@Component({
    name: "EditDialog",
    components: {
     EditRegistrationDialog
  },
})
export default class extends Vue {
    private dialogVisible = false;
    private payService = new VipPaySettingService();
    postItem = new OptionSettingsDto();
    payDeatail: PayDetail;
    private isUpdating = false;
    changeVisible: boolean = false
    vipRarionGrade:any;

    constructor() {
        super();
        this.payDeatail = new PayDetail();
    }
    listenEventHide() {
    this.changeVisible = false
  }
    //修改回显的数据展示
    open(schoolId, shcoolName, result) {
        this.payDeatail.schoolId = schoolId;
        this.payDeatail.shcoolName = shcoolName;
        this.payDeatail.pays = result.map((x) => {
            return new VipPriceDto({
                id: x.id,
                isEnable: x.isEnable,
                originalAmout: x.originalAmout,
                amount: x.amount || x.originalAmout,
                tenantId: x.tenantId,
                description: x.description,
                month: x.month,
                type: x.type,
                registrationType: x.registrationType,
                days:x.days,
                expiredDateTime: x.expiredDateTime
                    ? moment(
                          moment(x.expiredDateTime).format(
                              "YYYY-MM-DD HH:mm:ss"
                          )
                      )
                    : null,
                sortedNo: x.sortedNo,
                vipRarionGrade:x.vipRarionGrade,
                gradeNo : x.gradeNo
            });
        });
        if(result.length>0){
          this.vipRarionGrade =result[0].vipRarionGrade
        }
        this.$alert(
            "会员计费模式分为按月计费和按截止日期计费，没有设置截止日期为按月计费，否则为按截止日期计费。",
            "会员计费模式",
            {
                confirmButtonText: "确定",
                callback: (action) => {
                    this.dialogVisible = true;
                },
            }
        );
    }

    // 关闭弹框
    hideModal() {
        this.$emit("listenEventHide");
        this.dialogVisible = false;
    }

    stateChange() {
        alert();
    }

    removeSetting(id,index) {
        if(id== -1){
            //删除本地
             this.payDeatail.pays.splice(index,1)
        }else{
            this.$confirm("确定删除该会员充值套餐？", "提示").then(() => {
            this.payService.removeVipPriceSettingById(id).then(() => {
                this.$notify.success("删除成功!");
                this.$emit("success");
                this.dialogVisible = false;
            })
            .catch(()=>{
              this.$notify.warning("删除失败,请稍后重试!");
            });
        });
        }
    }

    editSetting(id){
        this.payService.getRegistrationPackages(id,this.payDeatail.schoolId).then((result) => {
            (this.$refs.editRegistration as EditRegistrationDialog).open(id,this.payDeatail.schoolId,this.payDeatail.shcoolName,result)

        })
    }

    submit() {
        let vipPrices = [];
        this.isUpdating = true;
        for (const item of this.payDeatail.pays) {
            if (!item.expiredDateTime && item.month == 0 && item.type == 0) {
                this.isUpdating = false;
                this.$notify.warning(
                    "未设置截止日期且月份为0，会员的过期时间将不会有任何变化!"
                );
                return;
            }

            if(item.sortedNo.toString()==''){
                this.isUpdating=false;
                this.$notify.warning("排序号码不能为空!");
                return;
            }

            vipPrices.push(
                new VipPriceDto({
                    id: item.id,
                    isEnable: item.isEnable,
                    originalAmout: item.originalAmout,
                    amount: item.amount,
                    description: item.description,
                    tenantId: 0,
                    month: item.month,
                    days:item.days,
                    registrationType:item.registrationType,
                    type:item.type,
                    expiredDateTime: item.expiredDateTime
                        ? moment(
                              moment(item.expiredDateTime).format(
                                  "YYYY-MM-DD HH:mm:ss"
                              )
                          )
                        : null,
                    sortedNo: item.sortedNo,
                    isDefaltChick:false,
                    gradeNo:item.gradeNo
                })
            );
        }
        this.payService
            .updateVipOptions(
                new OptionSettingsDto({
                    schoolId: this.payDeatail.schoolId,
                    schoolName: this.payDeatail.shcoolName,
                    isShow:false,
                    vipPrices: vipPrices,
                })
            )
            .then((result) => {
                this.isUpdating = false;
                this.$emit("success");
                this.dialogVisible = false;
                this.$message.success("修改成功");
            })
            .catch(() => {
                this.isUpdating = false;
            });
    }

    private handleSwitchChange() {
        this.payDeatail = JSON.parse(
            JSON.stringify(this.payDeatail)
        ) as PayDetail;
    }

    //新增收费套餐
    addNewPrice() {

        var newPrice = new VipPriceDto({
            id: -1,
            isEnable: true,
            originalAmout: 0,
            amount: 0,
            tenantId: -1,
            description: "新增套餐",
            month: 0,
            expiredDateTime: moment(),
            sortedNo: 0,
            type:0,
            registrationType:0,
            days:0,
            isDefaltChick:false,
            vipRarionGrade :this.vipRarionGrade
        });

        this.payDeatail.pays.unshift(newPrice);

    }
}
